const mapData = {
	0: {
		title:"Saale - Remptendorf",
		img:"https://cdn.shopify.com/s/files/1/0605/1505/7884/files/1be20eb5-069e-4216-b7aa-e871e8b3d828.jpg?v=1682366004",
		left:59,
		top:55,
        description:"An unserem Anpflanzgebiet an der Saale hat der Borkenkäfer nur noch kahle Flächen hinterlassen. Insgesamt werden hier in den nächsten Jahren 13 Hektar aufgeforstet.",
		date:"10.11.2022",
		trees:"2.700",
		sorts:"Stieleiche, Vogelkirsche, Lärche",
        coordinates:"50.5421016, 11.7306611"
	},
	1: {
		title:"Dermbach - Gehaus",
		img:"https://cdn.shopify.com/s/files/1/0605/1505/7884/files/bp_20230324_054_1_1.jpg?v=1679830725",
		left:46,
		top:53,
        description:"Im März 2023 fand auf diesem Waldgrundstück unsere 3. Anpflanzaktion statt, bei der wir gemeinsam mit fleißigen Helfern symbolisch 300 Bäume gepflanzt haben.",
		date:"24.03.2023",
		trees:"300",
		sorts:"Stieleiche, Lärche, Bergahorn",
        coordinates:"50.7620402, 10.1039055"
	},
	2: {
		title:"Dermbach - Gehaus",
		img:"https://cdn.shopify.com/s/files/1/0605/1505/7884/files/nov_22-min.jpg?v=1678797600",
		left:44,
		top:53,
        description:"Auf diesem Grundstück fand unsere 2. Anpflanzaktion im November 2022 statt. Insgesamt haben wir einen Hektar aufgeforstet, wovon 300 Setzlinge eigenhändig durch unsere Baumpaten gepflanzt wurden.",
		date:"10.11.2022",
		trees:"300",
		sorts:"Stieleiche, Lärche",
        coordinates:"50.7578093, 10.1020846"
	},
	3: {
		title:"Dermbach - Tiefenort",
		img:"https://cdn.shopify.com/s/files/1/0605/1505/7884/files/jahreszeit_bild.jpg?v=1657734606",
		left:46,
		top:51,
        description:"In Tiefenort konnten wir im März 2022 einen Hektar Wald aufforsten, welcher durch den Orkan Kyrill zerstört wurde.",
		date:"10.03.2022",
		trees:"2.200",
		sorts:"Stieleiche, Weißtanne, Rotbuche, Bergahorn, Douglasie",
        coordinates:"50.8755976, 10.1113158"
	},
	4: {
		title:"Dermbach - Stöckigt",
		img:"https://cdn.shopify.com/s/files/1/0605/1505/7884/files/IMG_2772.png?v=1682366194",
		left:48,
		top:52,
        description:"Dieses Waldgrundstück mit ca. 10 Hektar wird fortlaufend aufgeforstet, die ersten Setzlinge wurden im März 2023 gepflanzt.",
		date:"24.03.2023",
		trees:"2.400",
		sorts:"Lärche, Vogelkirsche, Douglasie",
        coordinates:"50.7969505, 10.1216818"
	},
   5: {
		title:"Ruhla",
		img:"https://cdn.shopify.com/s/files/1/0605/1505/7884/files/IMG_2772.png?v=1682366194",
		left:51,
		top:51,
        description:"Dieses Waldgrundstück wird ab Herbst 2023 bepflanzt.",
		date:"Herbst 2023",
		trees:"-",
		sorts:"-",
        coordinates:"50.8738405, 10.4118077"
	}
};

let locations = Object.keys(mapData);
let buttonWrapper = document.getElementById("mapWrapper");
let sliderWrapper = document.getElementById('sliderWrapper')
let state =""

locations.forEach((key) => {
		/*Buttons generieren*/
		if (key == 0){state = "active"}else{state=""}
		buttonWrapper.innerHTML += "<button id='button" + key + "' class='slider-button " + state + "' data-slide='" + key + "'></button>";

		let left = mapData[key].left;
		let top = mapData[key].top;
		document.getElementById("button"+key).style.cssText += "left:"+left+"%;"+"top:"+top+"%;";
		
		/*Slides generieren*/
		let title = mapData[key].title;
		let img = mapData[key].img;
		let description = mapData[key].description;
		let date = mapData[key].date;
		let trees = mapData[key].trees;
		let sorts = mapData[key].sorts;
		let coordinates = mapData[key].coordinates;
		
		sliderWrapper.innerHTML += 
		"<div class='slide'" + state +">"
			+"<div class='sliderImage'>"
				+"<img class='sliderHeadImage' src="+img+" alt='map'>"
			+"</div>"
			+"<div class='image-with-text__content image-with-text__content--adapt sliderCard'>"
				+"<div class='sliderBody image-with-text__text rte'>"
					+"<div>"
						+"<h2 class='sliderTitle'><strong>"+title+"</strong></h2>"
					+"</div>"
					+"<div class='sliderItem'>"
						+"<div class='value'>"+description+"</div>"
					+"</div>"
					+"<div class='sliderItem'>"
						+"<div class='key'>"
							+"<h4 class='keyTitle'>"
								+"<strong>Datum</strong>"
							+"</h4>"
						+"</div>"
						+"<div class='value'>"+date+"</div>"
					+"</div>"
					+"<div class='sliderItem'>"
						+"<div class='key'>"
							+"<h4 class='keyTitle'>"
								+"<strong>Gepflanzte Bäume</strong>"
							+"</h4>"
						+"</div>"
						+"<div class='value'>"+trees+"</div>"
					+"</div>"
					+"<div class='sliderItem'>"
						+"<div class='key'>"
							+"<h4 class='keyTitle'>"
								+"<strong>Baumarten</strong>"
							+"</h4>"
						+"</div>"
						+"<div class='value'>"+sorts+"</div>"
					+"</div>"
					+"<div class='sliderItem'>"
						+"<div class='key'>"
							+"<h4 class='keyTitle'>"
								+"<strong>Koordinaten</strong>"
							+"</h4>"
						+"</div>"
						+"<div class='value'>"+coordinates+"</div>"
					+"</div>"
				+"</div>"
			+"</div>"
		+"</div>";
	}
);


/* Slider Funktion*/
const slider = document.querySelector('#jonnySlider .slider');
const slides = document.querySelectorAll('#jonnySlider .slide');
const buttons = document.querySelectorAll('#jonnySlider .slider-button');

let currentSlide = 1;

function goToSlide(slideNumber) {
  slider.style.transform = `translateX(-${(slideNumber - 1) * 100}%)`;
  slides[currentSlide - 1].classList.remove('active');
  slides[slideNumber - 1].classList.add('active');
  buttons[currentSlide - 1].classList.remove('active');
  buttons[slideNumber - 1].classList.add('active');
  currentSlide = slideNumber;
}

buttons.forEach((button, index) => {
  button.addEventListener('click', () => {
    goToSlide(index + 1);
  });
});

